export default "__VITE_ASSET__D_VN9kj8__"